import { z } from 'zod';

// Entity Type Schema
export const EntityTypeSchema = z.object({
  id: z.string().uuid(),
  organizationId: z.string().uuid(),
  typeId: z.string().min(1).max(50),
  name: z.string().min(1).max(100),
  pluralName: z.string().max(100).optional().nullable(),
  description: z.string().optional().nullable(),
  color: z.string().regex(/^#[0-9A-Fa-f]{6}$/).default('#6366F1'),
  icon: z.string().max(50).optional().nullable(),
  order: z.number().int().default(0),
  isDefault: z.boolean().default(false),
  isHidden: z.boolean().default(false),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type EntityType = z.infer<typeof EntityTypeSchema>;

// Create Entity Type Schema
export const CreateEntityTypeSchema = z.object({
  typeId: z.string().min(1).max(50),
  name: z.string().min(1).max(100),
  pluralName: z.string().max(100).optional(),
  description: z.string().optional(),
  color: z.string().regex(/^#[0-9A-Fa-f]{6}$/).default('#6366F1'),
  icon: z.string().max(50).optional(),
  order: z.number().int().optional(),
  isDefault: z.boolean().optional(),
});

export type CreateEntityType = z.infer<typeof CreateEntityTypeSchema>;

// Update Entity Type Schema
export const UpdateEntityTypeSchema = CreateEntityTypeSchema.partial();

export type UpdateEntityType = z.infer<typeof UpdateEntityTypeSchema>;

// Reorder Entity Types Schema
export const ReorderEntityTypesSchema = z.object({
  typeIds: z.array(z.string().uuid()),
});

export type ReorderEntityTypes = z.infer<typeof ReorderEntityTypesSchema>;
